import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { LoggedUserService } from '../services/logged-user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private jwtHelper: JwtHelperService,
    private loggedUserService: LoggedUserService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const token = localStorage.getItem('access_token');

    // If user is already authenticated, redirect to home
    if (token && !this.jwtHelper.isTokenExpired(token) && this.loggedUserService.loggedUser) {
      return this.router.createUrlTree(['/home']);
    } else {
      // If user is not authenticated, allow access to login page
      return true;
    }
  }
}
